const bounceObject = (name, bounceSpeed = 1) => {
  var box = document.getElementById(name);
  if (typeof box !== "undefined" && box !== null) {
    // box = document.getElementsByClassName("p4k-bounce-skull")[0],
    var win = window,
      ww = win.innerWidth,
      wh = win.innerHeight,
      translateX = Math.floor(Math.random() * ww + 1),
      translateY = Math.floor(Math.random() * wh + 1),
      boxRect = box.getBoundingClientRect(),
      boxWidth = boxRect.width,
      boxHeight = boxRect.height,
      xMax = win.innerWidth - boxWidth,
      yMax = win.innerHeight - boxHeight,
      request = null,
      direction = Math.floor(Math.random() * 4),
      speed = bounceSpeed,
      timeout = null;
    init();
    console.log(boxHeight, boxWidth);

    window.addEventListener(
      "resize",
      function (e) {
        clearTimeout(timeout);
        timeout = setTimeout(update, 100);
      },
      false
    );

    function init() {
      request = requestAnimationFrame(init);
      move();
    }

    function update() {
      xMax = win.innerWidth - boxWidth;
      yMax = win.innerHeight - boxHeight;
    }

    function move() {
      setDirection();
      setStyle(box, {
        transform: `translate3d(${translateX}px, ${translateY}px, 0)`,
      });
    }

    function setDirection() {
      switch (direction) {
        case 0:
          translateX += speed;
          translateY -= speed;
          break;
        case 1:
          translateX -= speed;
          translateY -= speed;
          break;
        case 2:
          translateX += speed;
          translateY += speed;
          break;
        case 3:
          translateX -= speed;
          translateY += speed;
          break;
      }
      setLimits();
    }

    function setLimits() {
      if (translateY <= 0) {
        if (direction == 1) {
          direction = 3;
        } else if (direction == 0) {
          direction = 2;
        }
      }
      if (translateY >= yMax) {
        if (direction == 2) {
          direction = 0;
        } else if (direction == 3) {
          direction = 1;
        }
      }
      if (translateX <= 0) {
        if (direction == 1) {
          direction = 0;
        } else if (direction == 3) {
          direction = 2;
        }
      }
      if (translateX >= xMax) {
        if (direction == 0) {
          direction = 1;
        } else if (direction == 2) {
          direction = 3;
        }
      }
    }

    function getVendor() {
      var ua = navigator.userAgent.toLowerCase(),
        match =
          /opera/.exec(ua) ||
          /msie/.exec(ua) ||
          /firefox/.exec(ua) ||
          /(chrome|safari)/.exec(ua) ||
          /trident/.exec(ua),
        vendors = {
          opera: "-o-",
          chrome: "-webkit-",
          safari: "-webkit-",
          firefox: "-moz-",
          trident: "-ms-",
          msie: "-ms-",
        };

      if (vendors[match[0]] != null) return vendors[match[0]];
      return "-webkit-";
    }

    function setStyle(element, properties) {
      // var prefix = getVendor(),
      var property,
        css = "";
      for (property in properties) {
        css += property + ": " + properties[property] + ";";
        // css += prefix + property + ": " + properties[property] + ";";
      }
      element.style.cssText += css;
    }
  }
};

bounceObject("p4k-bounce-skull");
bounceObject("p4k-bounce-p4k");
bounceObject("p4k-bounce-lifeanddeath");
bounceObject("p4k-bounce-p4kasso");
bounceObject("p4k-bounce-product-title", 0.5);
bounceObject("p4k-bounce-oblique");
